@if (application(); as application) {
  <div class="application-details">
    <div class='row'>
      <div class='col-md-3'>
        <app-label label='Data utworzenia:'>
          {{ application?.createdAt | date }}
        </app-label>
      </div>
      <div class='col-md-3'>
        <app-label label='Data zatwierdzenia:'>
          {{ application?.updatedAt | date }}
        </app-label>
      </div>
      <div class='col-md-6'>
        <app-label label='Numer sprawy:'>
          {{ application?.caseNumber || '-' }}
        </app-label>
      </div>
    </div>
    <ng-container *ngIf='shipments()?.length'>
      <br>
      <app-decision-data-preview [canPay]="canPay()" [shipments]="shipments()">
      </app-decision-data-preview>
      <br>
    </ng-container>
    <app-applicant-preview
      [application]="application"
      [expanded]="expanded">
    </app-applicant-preview>
    <br>
    <h3>
      Dane wniosku
    </h3>
    <app-application-data-preview [application]="application">
    </app-application-data-preview>
    <br>
    <h3>
      Informacje na temat inwestycji
    </h3>
    <div class="row">
      <div class="col-12">
        <app-label label="Lokalizacja inwestycji:">
          {{ application?.investmentLocation || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Cel inwestycji:">
          {{ application?.investmentPurpose || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Harmonogram inwestycji:">
          {{ application?.investmentSchedule || '-' }}
        </app-label>
      </div>
      <div class="col-12">
        <app-label label="Wymagania infrastrukturalne inwestycji:">
          {{ application?.investmentInfrastructureRequirements || '-' }}
        </app-label>
      </div>
    </div>
    <br>
    <h3>
      Zgody
    </h3>
    <app-agreements-data-preview [application]="application">
    </app-agreements-data-preview>
    <br>
    <h3>
      Załączniki
    </h3>
    <app-attachments-data-preview [application]="application">
    </app-attachments-data-preview>
  </div>
}
